/*
  How long a string is, counted in the units a person counts in.

  String.length and String.slice work in UTF-16 code units, and an emoji or a
  supplementary-plane letter is stored as a surrogate pair of two of them. Counting that way
  reports one emoji as two characters, and slicing that way can cut between the halves of a
  pair and leave a lone surrogate behind, which encodeURIComponent then rejects with
  'URI malformed'. Array.from iterates a string by code point, so a pair is one step and is
  never split.

  This sits in a module of its own rather than inside a feature, because two unrelated places
  need the same answer: feedbackDraft clamps its fields on it, and the shared CharacterCount
  component displays it. A shared component must not import from a feature module to get a
  rule as general as how long a string is.

  Code points, not grapheme clusters: a flag or a family emoji is several code points and is
  counted here as several characters. That is the same basis the limits themselves are
  enforced on, and agreeing with the enforcement is the whole reason this function exists.
*/
export function countCharacters(value: string): number {
  return Array.from(value).length
}
